import { defaultBuild } from './DefaultSimBuild';
import { TabColumnOrder, kdTabColumnVisibility } from './visibilityDefaults';
import { AppState, IntelState } from '../@types/State';

const initialAppState: AppState = {
  darkMode: true,
  usePinchZoom: false,
  useAutoRefresh: true,
  tokenCredentials: null,
  isDev: false,
  simStates: [
    { ...defaultBuild, buildName: 'Build 1', buildIndex: 0 },
    { ...defaultBuild, buildName: 'Build 2', buildIndex: 1 },
    { ...defaultBuild, buildName: 'Build 3', buildIndex: 2 },
    { ...defaultBuild, buildName: 'Build 4', buildIndex: 3 },
    { ...defaultBuild, buildName: 'Build 5', buildIndex: 4 },
  ],
  zoom: 'default',
};

const initialIntelState: IntelState = {
  server: 1,
  columnVisibility: kdTabColumnVisibility,
  columnOrder: TabColumnOrder,
  enemyKd: '1:1',
  enemyData: undefined,
  ownData: undefined,
  ownPlan: undefined,
  enemyPlan: undefined,
  loading: false,
  kingdomNews: undefined,
  provinceNews: undefined,
  racesWol: undefined,
  racesGen: undefined,
  ticks: undefined,
  currentTick: undefined,
};

export { initialAppState as initialState, initialIntelState };
